<div class="tags-section" #dropdownWrapper (click)="isDropdownOnTop ? toggleDropdown() : '';$event.stopPropagation()" [class.tag-container]="isDropdownOnTop">
    <i class="fa-solid fa-tag tag-position" *ngIf="!isDropdownOnTop"></i>
    <span class="tag" *ngFor="let tag of selectedTagsList">{{ tag.description }}<i class="fa-solid fa-xmark remove-button" (click)="removeTag(tag);$event.stopPropagation()"></i></span>
    <span class="add-tag" *ngIf="!isDropdownOpen" (click)="toggleDropdown() ;$event.stopPropagation()">
        {{(isDropdownOnTop ? (selectedTagsList.length == 0 ? 'Add tags' : '') : 'Add a tag')}}
    </span>
    <div class="dropdown" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
        <input type="text" #dropdownInput
               [(ngModel)]="searchText"
               (input)="filterTags()"
               (keydown)="onKeyDown($event)"
               class="form-control"/>
        <ul class="dropdown-menu show no-border-top slim-scroll"
            *ngIf="filteredTags.length > 0; else noResult"
            [class.keyboard-active]="isKeyboardMode"
            (mouseenter)="onDropdownMouseEnter()"
            (mouseleave)="onDropdownMouseLeave()"
            (scroll)="onDropdownScroll()">

            <li *ngFor="let tag of filteredTags; let i = index"
                class="option"
                [attr.data-index]="i"
                (click)="selectTag(tag);$event.stopPropagation()"
                (mouseenter)="hoveredIndex = i; isKeyboardMode = false"
                (mousemove)="hoveredIndex = i"
                (mouseleave)="hoveredIndex = -1"
                [class.active]="isKeyboardMode && i === activeIndex"
                [class.hovered]="!isKeyboardMode && pointerInside && i === hoveredIndex">
                {{ tag.description }}
            </li>
        </ul>
        <ng-template #noResult>
            <ul class="dropdown-menu show no-border-top slim-scroll">
                <ng-container *ngIf="loadingHashtags; else noTags">
                    <li class="placeholder-color">Loading..</li>
                </ng-container>
                <ng-template #noTags>
                    <li (click)="onEnter(); $event.stopPropagation()" class="new-tag">Add {{searchText}} as tag</li>
                    <li class="placeholder-color">No result</li>
                </ng-template>
            </ul>
        </ng-template>
    </div>
</div>
